// extracted by mini-css-extract-plugin
export default {"l_PaymentDetail_main":"PaymentDetail_l_PaymentDetail_main__KeXKG","l_Hr":"PaymentDetail_l_Hr__pTmUU"};